import React from 'react'
import './index.less'
import { urlObjectToStrings, getParams } from './../../../assets/js/utils'
import imgURL from '../../../assets/images/jiantou.png'
function LoanTwoColumns (props) {
    const { data: { id, position, sublist = [] }, buriedPointEvent } = props
    const handleNextPage = (type, url) => {
        if (!url) return;
        let params = {};
        let odlURL, odlParam;
        if (url.indexOf("?") != -1) {
            odlURL = url.split("?")[0]; 
            odlParam = `?${url.split("?")[1]}`;
            params = getParams(odlParam);
        }
        params.fromSource = "GMZXAPP";
        let newURL = urlObjectToStrings(odlURL, params);
        window.GomeJSBridge.pushWindow(null, null, newURL)
    };
    return (
        <React.Fragment>
            {sublist.map(item => (
                <div className="LoanTwoColumns_box" key={item.id}>
                    <div
                        className="content_card"
                        onClick={() => {
                            buriedPointEvent({
                                button_name: `${item.newBalanceTitle}`,
                                button_id: `${id}`,
                                button_order: '1',
                                area_order: position,
                                button_area: `${position}`
                            })
                            handleNextPage('01', item.newBalanceUrl)
                        }}
                    >
                        <div className="card_title">
                            <span>{item.newBalanceTitle}</span>
                            <img src={imgURL} className="card_arrows" />
                        </div>
                        <p className="card_amount">{item.newBalanceAmount}</p>
                        <p className="card_hint">{item.newBalanceDesc}</p>
                    </div>
                    <div
                        className="content_card"
                        onClick={() => {
                            buriedPointEvent({
                                button_name: `${item.loanTitle}`,
                                button_id: `${id}`,
                                button_order: '2',
                                area_order: position,
                                button_area: `${position}`
                            })
                            handleNextPage('02', item.loanUrl)
                        }}
                    >
                        <div className="card_title">
                            <span>{item.loanTitle}</span>
                            <img src={imgURL} className="card_arrows" />
                        </div>
                        <p className="card_amount">{item.loanAmount}</p>
                        <p className="card_hint">{item.loanDesc}</p>
                    </div>
                </div>
            ))}
        </React.Fragment>
    )
}
export default LoanTwoColumns
